import barrier from '../imgs/barrier-article.jpeg';
import prime from '../imgs/prime-article.jpeg';
import api from '../imgs/api-article.jpeg';

const pubs = [
  {
    id: 1,
    image: barrier,
    alt: 'First Article',
    ref: 'https://hackernoon.com/the-coding-barrier-a-simple-guide-to-clearing-the-first-hurdle-n33436oi',
    title: 'The Coding Barrier: A Simple Guide to Clearing The First Hurdle',
  },
  {
    id: 2,
    image: prime,
    alt: 'Second Article',
    ref: 'https://hackernoon.com/get-to-know-prime-the-ruby-class-for-sustaining-prime-numbers-ef6h365u',
    title: 'Get To Know Prime: The Ruby Class For Sustaining Prime Numbers',
  },
  {
    id: 3,
    image: api,
    alt: 'Third Article',
    ref: 'https://hackernoon.com/how-to-handle-rest-api-requests-in-react-vg1e32rn',
    title: 'How to Handle REST API Requests in React',
  },
];

export default pubs;
